<template>
  <div v-loading="pageLoading">
    <div>
      <el-form label-width="110px" :model="formLabelAlign">
        <el-form-item label="是否為重要消息">
          <template>
            <el-radio v-model="formLabelAlign.impMsg" label="1">是</el-radio>
            <el-radio v-model="formLabelAlign.impMsg" label="0">否</el-radio>
          </template>
        </el-form-item>
        <el-form-item prop="startInfoTime" label="發佈時間">
          <el-date-picker
            :picker-options="pickerOptions"
            type="datetime"
            v-model="formLabelAlign.startInfoTime"
            placeholder="選擇時間"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 300px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="endInfoTime" label="移除時間">
          <el-date-picker
            :picker-options="pickerOptions2"
            type="datetime"
            v-model="formLabelAlign.endInfoTime"
            placeholder="選擇時間"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 300px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="關閉視頻方法">
          <template>
            <el-radio v-model="formLabelAlign.closeSetting" label="0"
              >關閉按鈕</el-radio
            >
            <el-radio v-model="formLabelAlign.closeSetting" label="1"
              >視頻結束後關閉</el-radio
            >
          </template>
        </el-form-item>
        <el-form-item label="標題">
          <el-input
            placeholder="請輸入標題"
            type="textarea"
            :rows="4"
            style="width: 300px"
            maxlength="60"
            show-word-limit
            v-model="formLabelAlign.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="簡介">
          <el-input
            placeholder="請輸入簡介"
            type="textarea"
            :rows="4"
            style="width: 300px"
            maxlength="300"
            show-word-limit
            v-model="formLabelAlign.intro"
          ></el-input>
        </el-form-item>
        <el-form-item label="PDF封面">
          <el-upload
            class="upload-demo"
            action=""
            accept=".jpg,.png,.gif"
            :on-remove="handleRemove"
            :file-list="fileList"
            :auto-upload="false"
            list-type="picture-card"
            :on-change="changeFile"
            :limit="1"
            :on-exceed="exceed"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip" style="color: #ff0000">
              建議圖片尺寸：1130px (闊)
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="PDF文件">
          <el-upload
            class="upload-demo"
            action=""
            accept=".pdf"
            :on-remove="handleRemove3"
            :file-list="fileList3"
            :auto-upload="false"
            :on-change="changeFile3"
            list-type="text"
            :limit="1"
            :on-exceed="exceed"
          >
            <el-button size="small" type="primary">點擊上傳</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="PDF標題">
          <el-input
            v-model="coverTitle"
            type="textarea"
            :rows="4"
            style="width: 300px"
            maxlength="60"
            show-word-limit
            placeholder="請輸入PDF標題"
          ></el-input>
        </el-form-item>
        <el-form-item label="PDF簡介">
          <el-input
            v-model="coverContent"
            type="textarea"
            :rows="4"
            style="width: 300px"
            maxlength="300"
            show-word-limit
            placeholder="請輸入PDF簡介"
          ></el-input>
        </el-form-item>
        <el-form-item label="視頻" v-show="fileList1.length == 0">
          <el-upload
            class="upload-demo"
            action=""
            accept=".MP4,.AVI"
            :on-remove="handleRemove2"
            :file-list="fileList2"
            :auto-upload="false"
            list-type="text"
            :on-change="changeFile2"
            :limit="1"
            :on-exceed="exceed"
          >
            <el-button size="small" type="primary">點擊上傳</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="圖片" v-show="fileList2.length == 0">
          <el-upload
            class="upload-demo"
            action=""
            accept=".bmp,.jpg,.png,.tif,.gif,.pcx,.tga,.exif,.fpx,.svg,.psd,.cdr,.pcd,.dxf,.ufo,.eps,.ai,.raw,.WMF,.webp"
            :on-remove="handleRemove1"
            :file-list="fileList1"
            :auto-upload="false"
            list-type="picture-card"
            :on-change="changeFile1"
            multiple
            :limit="10"
            :on-exceed="exceed2"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip" style="color: #ff0000">
              建議圖片尺寸：1130px (闊)
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件標題">
          <el-input
            v-model="fileTitle"
            type="textarea"
            :rows="4"
            style="width: 300px"
            maxlength="60"
            show-word-limit
            placeholder="請輸入文件標題"
          ></el-input>
        </el-form-item>
        <el-form-item label="文件簡介">
          <el-input
            v-model="fileContent"
            type="textarea"
            :rows="4"
            style="width: 300px"
            maxlength="300"
            show-word-limit
            placeholder="請輸入文件簡介"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="dialog-footer">
        <el-button @click="back()">取 消</el-button>
        <el-button type="primary" @click="addInformation">發 佈</el-button>
      </div>
      <el-button class="back" @click="back()">返 回</el-button>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data() {
    return {
      pageLoading: false,

      pickerOptions: {
        // 時間限制
        disabledDate(time) {
          return time.getTime() <= Date.now() - 3600 * 1000 * 24;
        },
      },
      pickerOptions2: {
        // 時間限制
        disabledDate(time) {
          return (
            time.getTime() <=
            new Date(that.formLabelAlign.startInfoTime) - 3600 * 1000 * 24
          );
        },
      },
      formLabelAlign: {
        infoType: "4",
        impMsg: "1",
        startInfoTime: "",
        endInfoTime: "",
        closeSetting: "0",
        title: "",
        intro: "",
      },
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      coverTitle: "",
      coverContent: "",
      fileTitle: "",
      fileContent: "",
    };
  },
  mounted() {
    that = this;
    $("#pageHead").text("員工通訊");
  },
  methods: {
    handleRemove(file, fileList) {
      //文件刪除
      this.fileList = fileList;
    },
    handleRemove1(file, fileList) {
      //文件刪除
      this.fileList1 = fileList;
    },
    handleRemove2(file, fileList) {
      //文件刪除
      this.fileList2 = fileList;
    },
    handleRemove3(file, fileList) {
      //文件刪除
      this.fileList3 = fileList;
    },
    changeFile(file, fileList) {
      var audit = this.utils.detectionImageSizeType(file);
      console.log(audit);
      if (audit) {
        this.fileList.push(file);
      } else {
        fileList.pop();
      }
    },
    changeFile1(file, fileList) {
      var audit = this.utils.detectionImageSizeType(file);
      console.log(audit);
      if (audit) {
        this.fileList1.push(file);
      } else {
        fileList.pop();
      }
    },
    changeFile2(file, fileList) {
      var audit = this.utils.detectionVideoSizeType(file);
      console.log(audit);
      if (audit) {
        this.fileList2.push(file);
      } else {
        fileList.pop();
      }
    },
    changeFile3(file, fileList) {
      this.fileList3 = fileList;
    },
    exceed() {
      this.$message({
        type: "warning",
        message: "該類型只能上傳一個!",
      });
    },
    exceed2() {
      this.$message({
        type: "warning",
        message: "圖片的上限為10張!",
      });
    },
    addInformation() {
      var form = this.formLabelAlign;
      let formData = new FormData();
      for (let item in form) {
        if (form[item] == "" || form[item] == "[]") {
          this.$message({
            type: "warning",
            message: "請填寫完整!",
          });
          return;
        }
        formData.append(item, form[item]);
      }
      var fileList = this.fileList;
      var cover = new FormData();
      var fileList1 = this.fileList1;
      var fileList2 = this.fileList2;
      var fileList3 = this.fileList3;

      if (fileList3.length > 0) {
        if (that.coverTitle == "") {
          this.$message({
            type: "warning",
            message: "請填填寫PDF標題!",
          });
          return;
        }
        if (that.coverContent == "") {
          this.$message({
            type: "warning",
            message: "請填填寫PDF簡介!",
          });
          return;
        }
        if (fileList.length == 0) {
          this.$message({
            type: "warning",
            message: "請填新增PDF封面!",
          });
          return;
        }
        cover.append("file", fileList[0].raw);
        formData.append("coverTitle", that.coverTitle);
        formData.append("coverContent", that.coverContent);
        for (let i = 0; i < fileList3.length; i++) {
          formData.append("file", fileList3[i].raw);
        }
      } else {
        this.$message({
          type: "warning",
          message: "請上传PDF文件",
        });
        return;
      }
      if (fileList1.length > 0) {
        if (that.fileTitle == "") {
          this.$message({
            type: "warning",
            message: "請填填寫文件標題!",
          });
          return;
        }
        if (that.fileContent == "") {
          this.$message({
            type: "warning",
            message: "請填填寫文件簡介!",
          });
          return;
        }
        formData.append("fileTitle", that.fileTitle);
        formData.append("fileContent", that.fileContent);
        for (let i = 0; i < fileList1.length; i++) {
          formData.append("file", fileList1[i].raw);
        }
      }
      if (fileList2.length > 0) {
        if (that.fileTitle == "") {
          this.$message({
            type: "warning",
            message: "請填填寫文件標題!",
          });
          return;
        }
        if (that.fileContent == "") {
          this.$message({
            type: "warning",
            message: "請填填寫文件簡介!",
          });
          return;
        }
        formData.append("fileTitle", that.fileTitle);
        formData.append("fileContent", that.fileContent);
        for (let i = 0; i < fileList2.length; i++) {
          formData.append("file", fileList2[i].raw);
        }
      }
      this.$LoadingTitle = "正在上傳，請稍等……";
      this.pageLoading = true
      this.axios
        .post("/terminal/initialize/addCoverImg", cover, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res) {
            formData.append("coverImg", res.result);
            that.axios
              .post("/manage/addManInformation", formData, {
                headers: {
                  "content-type": "multipart/form-data",
                },
              })
              .then(function (res) {
                if (res) {
                  that.$message({
                    type: "success",
                    message: "發佈成功!",
                  });
                  setTimeout(function () {
                    that.$router.go(-1);
                  }, 1000);
                } else {
                  this.pageLoading = false
                }
              });
          } else {
            this.pageLoading = false
          }
        });
    },
    back() {
      if (
        this.formLabelAlign.startInfoTime ||
        this.formLabelAlign.endInfoTime ||
        this.formLabelAlign.title ||
        this.formLabelAlign.intro ||
        this.fileList.length > 0 ||
        this.fileList3.length > 0 ||
        this.fileList2.length > 0 ||
        this.coverTitle ||
        this.coverContent ||
        this.fileList1.length > 0 ||
        this.fileTitle ||
        this.fileContent
      ) {
        this.$confirm("資料尚未儲存，確定離開?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.back(-1);
          })
          .catch(() => {});
      } else {
        this.$router.back(-1);
      }
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}

.back {
  position: absolute;
  top: 90px;
  right: 45px;
}
.el-upload__tip {
  color: #ff0000;
}
</style>
